<template>
  <div>
    <div class="title">
        <span style="cursor: pointer" @click="$router.go(-1)">数据分析</span>
        > <span>商品销售</span>
    </div>
    <div class="concent">
      <div class="main">
        <!-- 搜索框渲染 -->
        <div class="demo-form-title">
            <div>
              <span style="margin-right:11px">分类名称:</span>
              <el-cascader
              placeholder="请选择分类"
              clearable
              :props="{ value: 'goodsTypeId', label: 'name', multiple: false, expandTrigger: 'hover' }"
              :options="customers"
              collapse-tags
              v-model="ruleForm.prolei"></el-cascader>
            </div>
            <div style="margin-left:50px">
              <Todayapick :SubmitBleen="SubmitBleen" @TodayapickChange="TodayapickChange" @Blanking="Blanking"></Todayapick>
            </div>
        </div>
      </div>
      <div class="concet">
          <!-- 饼状图渲染 -->
          <div style="width:400px;height:100%;background:#fff;border-radius: 2px;">
            <div class="CommodityAnalysis"> <img :src="ImgIcon" alt="" style="margin-right:6px"> 商品分析</div>
            <div id="EChart" style="width:320px;height:240px;margin:0 auto"></div>
            <div style="margin:41px 0px 60px 41px;padding-right:64px;height:230px;overflow-y: auto;">
              <ul>
                <li v-for="(item,index) in  PieChart" :key="index" class="CommodityBox">
                  <div class="Commodity" :style='{background:item.color}'></div> 
                  <div class="CommodityRbox"><span class="CommodityName">{{item.name}}</span><span class="CommodityVal">{{item.num}}</span></div>
                </li>
              </ul>
            </div>
          </div>
          <div style="flex:2;margin-left:20px;background:#fff">
            <div class="ExportBox">
              <span class="ExportBtn" @click="GetListExportBtn">导出表格</span>
            </div>
            <!-- 数据表格渲染 -->
            <el-table :data="tableData" style="width:90%" :header-cell-style="{background:'#F5F6FA'}" >
              <el-table-column header-align="center" align="center" prop="name" label="商品名称" width="180"> </el-table-column>
              <el-table-column header-align="center" align="center" prop="num" label="销售订单数量" width="180"> </el-table-column>
              <el-table-column header-align="center" align="center" prop="price" label="销售金额"> 
                <template slot-scope="scope">
                  <span>￥{{scope.row.price | rounding}}</span>
                </template>
              </el-table-column>
              <el-table-column header-align="center" align="center" prop="returnGoodsNum" label="退货数量"> </el-table-column>
              <el-table-column header-align="center" align="center" prop="returnGoodsPrice" label="退货金额">
                  <template slot-scope="scope">
                    <span>￥{{scope.row.returnGoodsPrice | rounding}}</span>
                  </template>
              </el-table-column>
            </el-table>
            <div  class="ExportBoxBm">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[10, 20, 30, 50]"
                layout="prev, pager, next, sizes, jumper"
                :total="totalAll">
              </el-pagination>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import Todayapick from "@/components/AnalysisPicker/TimePicker.vue"
let echarts = require("echarts");
export default {
  components:{Todayapick},
  data(){
    return{
      ImgIcon:require("@/assets/icon/icon_fenlei1.png"),//顶部图标
      SubmitBleen:true,//子组件是否展示搜索
      customers: [],//商品分类
      pickerOptions: { //限制选择当前时间之后的方法
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;  //如果没有后面的-8.64e6就是不可以选择今天的 
        }
      },
      ruleForm:{ //搜索框所需绑定的值
        prolei:[0],//商品的名称
        time:"",
        StartTime:"",
        EndTime:"",
      },
      tableData:[],//表格的数据
      pageSize:10,//分页每页的条数
      currentPage:0,//分页的页数
      totalAll:null,//列表的总条数
      PieChart:[],//饼图的数组
      shopIDList:[],//商户ID的数组
    }
  },
  created(){

  },
  filters: {
    rounding (value) {
      return value.toFixed(2)
    }
  },
  mounted(){
    let shopIDList=JSON.parse(localStorage.getItem("shop")).shop
    shopIDList.forEach(item=>{
      this.shopIDList.push(item.shop_id)
    })
    this.getGoodsClass();//获取商品分类的方法
    this.DefaultTime() //默认查询当前时间
    this.getCommodityArray(1,10) //默认进入页面查询的数据
    this.GetChartArray()
  },
  computed:{

  },
  methods:{
    ...mapActions({
        Classification: "dataAnalysis/Classification",//vuex中请求的接口商品销售分类
        GetCommodityList:"dataAnalysis/GetCommodityList",//vuex中请求的接口商品销售列表
        GetListExport:"dataAnalysis/GetListExport",//vuex中导出表格接口
        GetPieChart:"dataAnalysis/GetPieChart",//vuex中获取饼图的接口
    }),
    GetChartArray(){
      let params={
        "shopIdList":this.shopIDList,
        "pageSize":10,
        "pageIndex":1,
        "goodsTypeId":this.ruleForm.prolei[0],
        "timeBegin": this.ruleForm.StartTime,
        "timeEnd": this.ruleForm.EndTime
      }
      this.GetPieChart(params).then(res=>{
        if(res.code===10000){
          this.PieChart=res.data
          this.getRenderer()//商品销售饼状图渲染执行
        }
      })
    },
    getCommodityArray(index,size){ //默认进入页面查询的数据
      let params={
        "shopIdList":this.shopIDList,
        "pageSize":size,
        "pageIndex":index,
        "goodsTypeId":this.ruleForm.prolei[0],
        "timeBegin": this.ruleForm.StartTime,
        "timeEnd": this.ruleForm.EndTime
      }
      this.GetCommodityList(params).then(res=>{
        if(res.code===10000){
          this.tableData=res.data
          this.totalAll=res.total
        }
      })
    },
    DefaultTime(){ //默认查询当前时间
      var endData=new Date()
      var month = parseInt(endData.getMonth() + 1);
      var day = endData.getDate();
      var hous=endData.getHours()
      var minu=endData.getSeconds()
      var fend=endData.getMinutes()
        if (month < 10) {
          month = "0" + month;
        }
        if (day < 10) {
          day = "0" + day;
        }
        if (hous < 10) {
          hous = "0" + hous;
        }
        if (fend < 10) {
          fend = "0" + fend;
        }
        this.ruleForm.StartTime=endData.getFullYear() + "-" + month + "-" + day+" "+"00:00:00"
        this.ruleForm.EndTime=endData.getFullYear() + "-" + month + "-" + day+" "+hous+":"+fend+":"+minu
    },
    getGoodsClass() { //获取商品分类
      this.Classification().then((res) => {
          if (res.code == 10000) {
            this.customers = res.data;
          } else {
              this.$message.error(res.msg);
          }
      });
    },
    getRenderer() { //商品销售饼状图渲染事件
      let data=[]
      if(this.PieChart.length>0){
        for (var i =0;i<this.PieChart.length;i++){
          data.push({
              value:this.PieChart[i].num,
              name:this.PieChart[i].name
          })
        }
      }
      let EChart = echarts.init(document.getElementById("EChart"));
      let config = {
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          series: [
            {
              type: 'pie',
              radius:  ['50%', '70%'],
              center: ['50%', '50%'],
              selectedMode: 'single',
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
      };
      // 设置参数
      EChart.setOption(config);
      let brr=EChart.getModel().option.color
      let brrindex=-1
      for (let index = 0; index < this.PieChart.length; index++) {
        if(brrindex>=brr.length-1){
          brrindex=0
          this.PieChart[index].color=brr[brrindex];
        }else{
          brrindex++
          this.PieChart[index].color=brr[brrindex];
        }
        
      }

    },
    Blanking(event){ //搜索框置空事件
      if(event==true){
        this.DefaultTime() //默认查询当前时间
        this.ruleForm.prolei[0]=0
        this.pageSize=1
        this.currentPage=10
        this.getCommodityArray(1,10) //默认进入页面查询的数据
        this.GetChartArray()
      }
    },
    GetListExportBtn(){ //触发导出按钮的事件
      let params={
        "shopIdList":this.shopIDList,
        "pageSize":this.pageSize,
        "pageIndex":this.currentPage,
        "goodsTypeId":this.ruleForm.prolei[0],
        "timeBegin": this.ruleForm.StartTime,
        "timeEnd": this.ruleForm.EndTime
      }
      this.GetListExport(params).then((res) => {
          if (res.code == 10000) {
            this.getExcel(this.tableData) //前端实现导出execl触发方法
          } else {
              this.$message.error(res.msg);
          }
      });
    },
    TodayapickChange(event){ //搜索框子组件触发的方法 获取所需值
      this.ruleForm.StartTime=event.StartTime
      this.ruleForm.EndTime=event.EndTime
      this.getCommodityArray(this.currentPage,this.pageSize)
      this.GetChartArray()
    },
    handleSizeChange(val){ //分页的每页条数事件
      this.pageSize=val
      this.getCommodityArray(this.currentPage,this.pageSize) //默认进入页面查询的数据

    },
    handleCurrentChange(val){ //分页的页数事件
      this.currentPage=val
      this.getCommodityArray(this.currentPage,this.pageSize) //默认进入页面查询的数据

    },
    getExcel(arr) { //进行execl的表头
      require.ensure([], () => {
          // 这里 require 的地址指向你项目中 Export2Excel.js 文件存放地址
          const { export_json_to_excel } = require("../../../excel/Export2Excel.js");
          const tHeader = [
              "商品名称",
              "销售订单数量",
              "销售金额",
              "退货数量",
              "退货金额"
          ];
          const filterVal = [
              "name",
              "num",
              "price",
              "returnGoodsNum",
              "returnGoodsPrice",
          ];
          const data = this.formatJson(filterVal, arr);
          export_json_to_excel(tHeader, data, "商品销售数据");
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
  }
}
</script>
<style lang="scss" scoped>
ul,li{ 
  padding:0;
  margin:0;
  list-style:none;
}
/*设置宽度,轨道颜色*/
::-webkit-scrollbar {
	width:6px;
	height: 6px;
	background: #ccc;   /*可以设置轨道颜色*/
	padding-right: 2px;
	border-radius: 10px;
}
 
/*滚动条*/
::-webkit-scrollbar-thumb {
	background: #999;
	border-radius: 10px;
}
.main {
  min-width: 1200px;
  margin:16px 20px;
  background: #fff;
  padding: 15px 28px;
  border-radius: 2px;
}
.title {
    box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
    width: 100%;
    background: #fff;
    font-size: 18px;
    color: #333;
    width: 100%;
    padding: 16px 23px;
}
.demo-form-title{
  min-width: 1200px;
  display: flex;
  justify-content: flex-start;
  align-content: center;
  // .demo-form-fist{
  //   font-size: 16px;
  //   color: #333;
  // }
  // .demo-form-fu{
  //   margin-left: 19px;
  //   font-size: 14px;
  //   color: #999;
  // }
}
.el-form-item{
  margin: 0;
}
.concet{
  min-width: 1200px;
  margin: 20px;
  display: flex;
  justify-content: flex-start;
  // align-items: center;
  .CommodityAnalysis{
    padding:37px 0 20px 39px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
}
.ExportBoxBm{
  margin-top: 50px;
  display: flex;
  justify-content:center;
}
.ExportBox{
  width: 100%;
  background-color: #fff;
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
  padding: 20px 50px;
  border-radius: 2px;
  border-bottom:4px solid #F0F0F0;
  .ExportBtn{
    width: 80px;
    height:40px;
    background-color: #409EFF;
    text-align: center;
    border-radius: 5px;
    line-height: 40px;
    color: #fff;
    cursor: pointer;
  }
}
.CommodityBox{
  margin: 10px 0;
  display: flex;
  // justify-content: space-between;
  align-items: center;
  
  .Commodity{
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }
  .CommodityRbox{
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .CommodityName{
      margin-left: 5px;
      color: #999;
    }
    .CommodityVal{
      color: #409EFF;
    }
  }
  
}

</style>